/**
 * 禁止输入emoji表情
 * @param {string} val - 输入内容
 * @returns {boolean} - 校验结果 返回 true || false
 */
import React from "react";

export const inputRange = (val: string): string => {
  let iconRule1 =
    /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/gi;
  return val.replace(iconRule1, "");
};

// function Handler(fn) {
//   this.handler = fn;
//   this.next = null;
// }

// Handler.prototype.setNext = function setNext(h) {
//   this.next = h;
//   return h;
// };

// Handler.prototype.passRequest = function () {
//   const ret = this.handler.apply(this, arguments);
//   // 提前结束
//   if (!ret) {
//     return ret;
//   }

//  // 向后传递
//   if (this.next) {
//     return this.next.passRequest.apply(this.next, arguments);
//   }
//   return ret;
// };

// export class ChainHander {
//   public hander: (s: string) => boolean
//   public next
//   constructor(fn: (str: string) => boolean) {
//     this.hander = fn
//   }
//   public setNext(callback): () => boolean {
//     this.next = callback
//     return callback
//   }
//   public checkPass(...arg) {
//     const result = this.hander.apply(this, arg)
//     if (!result) {
//       return result
//     }

//     if (this.next != null) {
//       return this.next.checkPass.apply(this.next, arg)
//     }

//     return result
//   }
// }

export const throtte = (fn: Function, delay: number = 1500) => {
  let timer: NodeJS.Timer;
  let canCall = true;
  return function (arg) {
    if (canCall) {
      canCall = false;
      fn(arg);
    }
    timer = setTimeout(() => {
      canCall = true;
      clearTimeout(timer);
    }, delay);
  };
};

export const debounce = (fn: (...arg: any) => any, delay: number = 1500) => {
  let timer: NodeJS.Timeout | null = null;
  return function () {
    const context = this;
    const arg = arguments;
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      fn.apply(context, arg);
    }, delay);
  };
};

export function pxTransform(size: number, designWidth = 750): string {
  if (!size) return process.env.TARO_ENV === "h5" ? "0rem" : "0rpx";
  const deviceRatio = {
    640: 2.34 / 2,
    750: 1,
    828: 1.81 / 2,
  };
  if (process.env.TARO_ENV === "h5")
    return (
      Math.ceil(
        (((parseInt(`${size}`, 10) / 40) * 640) / designWidth) * 10000
      ) /
        10000 +
      "rem"
    );
  return `${size / deviceRatio[designWidth]}rpx`;
}

let flexGapSupported: boolean | undefined;
export const detectFlexGapSupported = () => {
  if (flexGapSupported !== undefined) {
    return flexGapSupported;
  }

  const flex = document.createElement("div");
  flex.style.display = "flex";
  flex.style.flexDirection = "column";
  flex.style.rowGap = "1px";

  flex.appendChild(document.createElement("div"));
  flex.appendChild(document.createElement("div"));

  document.body.appendChild(flex);
  flexGapSupported = flex.scrollHeight === 1;
  document.body.removeChild(flex);

  return flexGapSupported;
};

export interface Option {
  keepEmpty?: boolean;
}

export function toArray(
  children: React.ReactNode,
  option: Option = {}
): React.ReactElement[] {
  let ret: React.ReactElement[] = [];

  React.Children.forEach(children, (child: any | any[]) => {
    if ((child === undefined || child === null) && !option.keepEmpty) {
      return;
    }

    if (Array.isArray(child)) {
      ret = ret.concat(toArray(child));
    } else if (isFragment(child) && child.props) {
      ret = ret.concat(toArray(child.props.children, option));
    } else {
      ret.push(child);
    }
  });

  return ret;
}

function isFragment(object) {
  return (
    object.$$typeof === Symbol.for("react.element") &&
    object.type === Symbol.for("react.fragment")
  );
}

// 获取 校验银行卡
export const checkBankCard = (cardNo: string) => {
  if (!cardNo) return false;
  let tmp = true;
  let total = 0;
  for (let i = cardNo.length; i > 0; i--) {
    let num = +cardNo.substring(i, i - 1);
    if (((tmp = !tmp), tmp)) num = num * 2;
    const gw = num % 10;
    total += gw + (num - gw) / 10;
  }
  return total % 10 === 0;
};

/**
 * 格式化银行卡号
 *
 * @export
 * @param {string} cardNum 6217002712347888987
 * @param {boolean} mask  是否掩码
 * @returns {string}  6217 0027 1234 7888 987
 */
export function creditCard(cardNum: string, mask?: boolean): string {
  const newCardNum = cardNum
    .replace(/[^\d]/g, "")
    .replace(/(\d{4})(?=\d)/g, "$1 ");

  return mask ? newCardNum.replace(/\s(\d{4})(?!\d)/g, " ****") : newCardNum;
}

/**
 * 校验身份证号是否符合规范
 *
 * @export
 * @param {string} idcard
 * @returns {boolean}  true 符合 ｜ false 不符合
 */
export function verifyIdcard(idcard: string): boolean {
  if (!idcard) return false;
  let regex1 =
    /^[1-9][0-7]\d{4}((([0-9]{3}[1-9]|[0-9]{2}[1-9][0-9]{1}|[0-9]{1}[1-9][0-9]{2}|[1-9][0-9]{3})(((0[13578]|1[02])(0[1-9]|[12][0-9]|3[01]))|((0[469]|11)(0[1-9]|[12][0-9]|30))|(02(0[1-9]|[1][0-9]|2[0-8]))))|((([0-9]{2})(0[48]|[2468][048]|[13579][26])|((0[48]|[2468][048]|[3579][26])00))0229))\d{3}(\d|X|x)?$/;
  /* 身份号码位数及格式检验 */
  switch (idcard.length) {
    case 15:
      if (
        (parseInt(idcard.substr(6, 2)) + 1900) % 4 === 0 ||
        ((parseInt(idcard.substr(6, 2)) + 1900) % 100 === 0 &&
          (parseInt(idcard.substr(6, 2)) + 1900) % 4 === 0)
      ) {
        let regex2 =
          /^[1-9][0-9]{5}[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|[1-2][0-9]))[0-9]{3}$/; // 测试出生日期的合法性
        if (regex2.test(idcard)) {
          return true;
        }
        return false;
      }
      // eslint-disable-next-line
      let regex2 =
        /^[1-9][0-9]{5}[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|1[0-9]|2[0-8]))[0-9]{3}$/; // 测试出生日期的合法性
      if (regex2.test(idcard)) {
        return true;
      }
      return false;

    case 18:
      if (regex1.test(idcard)) {
        let S =
          (parseInt(idcard.charAt(0)) + parseInt(idcard.charAt(10))) * 7 +
          (parseInt(idcard.charAt(1)) + parseInt(idcard.charAt(11))) * 9 +
          (parseInt(idcard.charAt(2)) + parseInt(idcard.charAt(12))) * 10 +
          (parseInt(idcard.charAt(3)) + parseInt(idcard.charAt(13))) * 5 +
          (parseInt(idcard.charAt(4)) + parseInt(idcard.charAt(14))) * 8 +
          (parseInt(idcard.charAt(5)) + parseInt(idcard.charAt(15))) * 4 +
          (parseInt(idcard.charAt(6)) + parseInt(idcard.charAt(16))) * 2 +
          parseInt(idcard.charAt(7)) * 1 +
          parseInt(idcard.charAt(8)) * 6 +
          parseInt(idcard.charAt(9)) * 3;
        let Y = S % 11;
        let M = "F";
        let JYM = "10X98765432";
        M = JYM.substr(Y, 1);
        /* 判断校验位 */
        if (M === idcard.charAt(17).toUpperCase()) {
          return true;
        }
        return false;
      }
      break;
    default:
      return false;
  }

  return false;
}

export function tripleDefer(func: () => void): void {
  setTimeout(() => setTimeout(() => setTimeout(() => func())));
}

export function isString(v) {
  return typeof v === "string";
}

export function isFunction(v) {
  return typeof v === "function";
}

export function isEqual(x, y) {
  if (x === y) {
    return true;
  } else if (
    typeof x === "object" &&
    x !== null &&
    typeof y === "object" &&
    y !== null
  ) {
    const keysX = Object.keys(x);
    const keysY = Object.keys(y);
    if (keysX.length !== keysY.length) {
      return false;
    }
    for (const key of keysX) {
      if (!isEqual(x[key], y[key])) {
        return false;
      }
    }
    return true;
  }
  return false;
}

export function pick(obj: any, keys) {
  const r = {};
  keys.forEach(key => {
    r[key] = obj[key];
  });
  return r;
}

const idCounter = {};
export function uniqueId(prefix = "$unique$") {
  if (!idCounter[prefix]) {
    idCounter[prefix] = 0;
  }

  const id = ++idCounter[prefix];
  if (prefix === "$unique$") {
    return `${id}`;
  }

  return `${prefix}${id}`;
}

/**
 * 版本号比较进阶版
 * @param {string} ver1  5.19.1  前一个版本
 * @param {string} ver2  5.18.3  后一个版本
 * @returns {number}  1: 前一个版本 大于 后一个版本
 *                   -1: 前一个版本 小于 后一个版本
 *                    0: 前一个版本 等于 后一个版本
 */
export function compareVersion(ver1: string, ver2: string): number {
  let v1 = ver1.split(".");
  let v2 = ver2.split(".");
  const len = Math.max(v1.length, v2.length);

  // 调整两个版本号位数相同
  while (v1.length < len) {
    v1.push("0");
  }
  while (v2.length < len) {
    v2.push("0");
  }

  // 循环判断每位数的大小
  for (let i = 0; i < len; i++) {
    const num1 = parseInt(v1[i]);
    const num2 = parseInt(v2[i]);

    if (num1 > num2) {
      //前一个版本 大于 后一个版本
      return 1;
    } else if (num1 < num2) {
      //前一个版本 小于 后一个版本
      return -1;
    }
  }

  return 0;
}

export const replaceCharByIndex = (
  str: string,
  index: number,
  replace: string
) => {
  return str.substring(0, index) + replace + str.substring(index + 1);
};

/**
 * 车牌号正则校验
 *
 * @export
 * @param {string} str 车牌号
 * @returns {boolean} false | true
 */
export const isLicenseNo = (str: string): boolean => {
  let xreg =
    /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}(([0-9]{5}[DF]$)|([DF][A-HJ-NP-Z0-9][0-9]{4}$))/;
  let creg =
    /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳]{1}$/;
  if (str.length === 7) {
    return creg.test(str);
  } else if (str.length === 8) {
    return xreg.test(str);
  }
  return false;
};
